<template>
  <div class="tab-trucking">
    <tab-trucking-UICustom-layout :element-blocks="elementBlocks" :to-exo-system-hc="toExoSystemHc" style="min-width: 1200px;">
      <!--      海创定制-->
      <div slot="haichuang" class="section">
        <span class="title">{{ $t('CargoMsg.Cargo_VehicleInformation') }} <span v-if="!job.uuid" style="color: red; font-weight:lighter">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}</span> <span style="margin: 20px">{{ $t('CargoMsg.Cargo_DispatchVehicleNoteFields') }}</span>
          <span style="color: red; font-weight: bold">{{ $t('CargoMsg.Cargo_TTDEG') }}</span></span>
        <div style="display: flex;padding-bottom: 5px">
          <el-button no="addHcInfo" type="primary" :disabled="readonly || !job.uuid" @click="addHcInfoHandler">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="delHcInfo" :disabled="readonly || !job.uuid" type="danger" @click="delHcInfoHandler">{{ $t('SeaExport.Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          no="hcInfo"
          config-module="20250522"
          :grid-options="hcInfo.gridOptions"
          :grid-params.sync="hcInfo.gridParams"
          :column-defs="hcInfoColumnDef"
          :row-data="hcInfoTrucking"
          style="width:100%;padding-bottom: 5px"
          @gridReady="params=>{hcInfo.gridApi=params.api}"
        />
        <span class="title">{{ $t('Partners.doorInformation') }} </span>
        <div style="display: flex;padding-bottom: 5px;">
          <el-button no="addHcDoor" type="primary" :disabled="readonly || !job.uuid" @click="addHcDoorHandler(false)">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="delHcDoor" :disabled="readonly || !job.uuid" type="danger" @click="delHcDoorHandler">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="informationMaintenance" :disabled="readonly || !job.uuid" type="success" @click="addDoor">{{ $t('CargoMsg.Cargo_InformationMaintenance') }}</el-button>
        </div>
        <cargo-ag-grid
          no="hcInfo"
          config-module="20250523"
          :grid-options="hcDoor.gridOptions"
          :grid-params.sync="hcDoor.gridParams"
          :column-defs="hcDoorColumDef"
          :row-data="hcDoorTrucking"
          style="width:100%;"
          @gridReady="params=>{hcDoor.gridApi=params.api}"
        />
      </div>
      <!--      原页面-->
      <template>
        <div v-if="showSecondSync || job.multiplePickups" slot="DoorToDoorLoading" class="section">
          <span class="title">{{ $t('SeaExport.DoorToDoorLoading') }} <span style="color: red; font-weight:lighter;margin:30px;">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}</span></span>
          <div style="display:flex;flex-direction:column">
            <div v-if="showSecondSync">
              <el-button type="primary" @click="syncToDischargingTruckingInfo">{{ $t('SeaExport.SecondarySynchronization') }}</el-button>
            </div>
            <div v-if="job.multiplePickups">
              <cargo-ag-grid
                v-if="top.visible"
                no="1"
                :config-module="topConfigModuel"
                :grid-options="top.gridOptions"
                :grid-params.sync="top.gridParams"
                :column-defs="topColumnDefs"
                :row-data="trucking"
                style="width:100%;"
                @gridReady="params=>{topgridApi=params.api}"
              />
            </div>
            <div v-if="job.multiplePickups" class="app-main-inner-row operations" style="padding:5px 0">
              <div v-show="cooperateEdit" class="triggers">
                <div>
                  <el-button no="2" type="primary" :disabled="readonly" @click="copyNewHandler">{{ $t('SeaExport.copyAndAddPoItems') }}</el-button>
                  <el-button no="3" type="primary" :disabled="readonly" @click="addHandler">{{ $t('SeaExport.Add2') }}</el-button>
                  <el-button no="4" :disabled="!btnEnable.btDel " type="danger" @click="delHandler">{{ $t('SeaExport.Delete') }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template>
          <el-checkbox v-if="elementDict.multiplePickups.viewable" slot="multiplePickups" v-model="job.multiplePickups" no="5.1" :disabled="readonly || action==='add' || !elementDict.multiplePickups.writable" style="width: auto;" @change="multiPickupsChangeHandler">{{ elementDict.multiplePickups.label }}
          </el-checkbox>
          <el-checkbox v-if="elementDict.multipleCabinets.viewable && multiTruckingShow" slot="multipleCabinets" v-model="job.multipleCabinets" no="5.2" :disabled="readonly || action==='add' || !elementDict.multipleCabinets.writable" style="width: auto;" @change="changePickupsOrCabinets('Cabinets')">
            {{ elementDict.multipleCabinets.label }}
          </el-checkbox>
          <el-form-item v-if="elementDict.quantityGrossWeightVolume.viewable" slot="quantityGrossWeightVolume">
            <line-label slot="label" :class="elementDict.quantityGrossWeightVolume.isRequire ? 'blue' : ''" :label="elementDict.quantityGrossWeightVolume.label" />
            <div style="display: flex;">
              <el-input-number
                no="6"
                :value="truckingInfo.quantity||undefined"
                :disabled="readonly || !elementDict.quantityGrossWeightVolume.writable"
                :min="0"
                :max="999999"
                :precision="0"
                controls-position="right"
                style="width: 118px;margin-right: 5px;flex-grow: 1;"
                @input="val=>{truckingInfo.quantity=val}"
              />
              <el-input-number
                no="7"
                :value="truckingInfo.weight||undefined"
                :disabled="readonly || !elementDict.quantityGrossWeightVolume.writable"
                :min="0"
                :max="999999"
                :precision="3"
                controls-position="right"
                style="width: 118px;margin-right: 5px;flex-grow: 1;"
                @input="val=>{truckingInfo.weight=val}"
              />
              <el-input-number
                no="8"
                :value="truckingInfo.cubage||undefined"
                :disabled="readonly || !elementDict.quantityGrossWeightVolume.writable"
                :min="0"
                :max="999999"
                :precision="3"
                controls-position="right"
                style="width: 118px;flex-grow: 1;"
                @input="val=>{truckingInfo.cubage=val}"
              />
            </div>
          </el-form-item>
          <el-form-item v-if="elementDict.carryingCmp.viewable && !isSalesForSzfs" slot="carryingCmp" class="custom">
            <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
            <cargo-company-select
              no="9"
              :disabled="readonly || !elementDict.carryingCmp.writable"
              :method-params="{truckCmp:true,active:true}"
              :default-value="truckingInfo.carryingCmp||''"
              style="width:400px; display:inline-block"
              :latest-used-data-key="elementDict.carryingCmp.userCustomContent && elementDict.carryingCmp.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-carryingCmp' : ''"
              @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.driver.viewable && !isSalesForSzfs" slot="driver" class="custom">
            <line-label slot="label" :class="elementDict.driver.isRequire ? 'blue' : ''" :label="elementDict.driver.label" />
            <el-select
              v-model="truckingInfo.driver"
              :disabled="readonly || !elementDict.driver.writable"
              no="10"
              style="width:400px"
              :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              :allow-create="true"
              :clearable="true"
              filterable
              @change="carryingContactsChangeHandler(false, false)"
              @blur="selectContactBlur"
            >
              <el-option
                v-for="(item,index) in carryingContacts"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="elementDict.loadingDate.viewable" slot="loadingDate" class="custom">
            <line-label slot="label" :class="elementDict.loadingDate.isRequire ? 'blue' : ''" :label="elementDict.loadingDate.label" />
            <el-date-picker
              ref="loadingDate"
              v-model="truckingInfo.loadingDate"
              :disabled="readonly || !elementDict.loadingDate.writable"
              no="11"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:400px"
              @blur="()=> { handleBlur('loadingDate', null, true, true, truckingInfo) }"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.driverName.viewable && !isSalesForSzfs" slot="driverName" class="custom">
            <line-label slot="label" :class="elementDict.driverName.isRequire ? 'blue' : ''" :label="elementDict.driverName.label" />
            <el-select
              v-model="truckingInfo.driverName"
              :disabled="readonly || !elementDict.driverName.writable"
              style="width:400px"
              no="12"
              :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              :allow-create="true"
              :clearable="true"
              filterable
              @change="driverInfomationsChangeHandler"
            >
              <el-option
                v-for="(item,index) in driverInfomations"
                :key="index"
                :label="item.driverName"
                :value="item.driverName"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="elementDict.travelTime.viewable" slot="travelTime" class="custom">
            <line-label slot="label" :class="elementDict.travelTime.isRequire ? 'blue' : ''" :label="elementDict.travelTime.label" />
            <el-input-number
              v-model="truckingInfo.travelHour"
              :disabled="readonly || !elementDict.travelTime.writable"
              no="13"
              :min="0"
              controls-position="right"
              style="width:105px"
            />
            <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
            <el-input-number
              v-model="truckingInfo.travelMinute"
              :disabled="readonly || !elementDict.travelTime.writable"
              no="14"
              :min="0"
              :max="59"
              controls-position="right"
              style="width:100px"
            />
            <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
          </el-form-item>
          <el-form-item v-if="elementDict.doorMan.viewable" slot="doorMan" class="custom">
            <line-label slot="label" :class="elementDict.doorMan.isRequire ? 'blue' : ''" :label="elementDict.doorMan.label" />
            <el-input v-model="truckingInfo.doorMan" :disabled="readonly || !elementDict.doorMan.writable" no="15" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.doorAddr.viewable" slot="doorAddr" class="custom">
            <line-label slot="label" :class="elementDict.doorAddr.isRequire ? 'blue' : ''" :label="elementDict.doorAddr.label" />
            <el-input v-model="truckingInfo.doorAddr" :disabled="readonly || !elementDict.doorAddr.writable" no="16" type="textarea" :rows="3" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.zipCode.viewable" slot="zipCode" class="custom">
            <line-label slot="label" :class="elementDict.zipCode.isRequire ? 'blue' : ''" :label="elementDict.zipCode.label" />
            <el-input v-model="truckingInfo.zipCode" :disabled="readonly || !elementDict.zipCode.writable" no="zipCode" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.cityCode.viewable" slot="cityCode" class="auto-width">
            <line-label slot="label" :class="elementDict.cityCode.isRequire ? 'blue' : ''" :label="elementDict.cityCode.label" />
            <div style="display: flex;">
              <cargo-advance-select
                no="17"
                style="width:160px"
                :disabled="readonly || !elementDict.cityCode.writable"
                :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                tag-value="code"
                :cache="false"
                filterable
                :default-value="truckingInfo.cityCode"
                :static-options="cityList"
                :placeholder="$t('SeaExport.PleaseSelect')"
                @parentCallBack="p=>truckingInfo.cityCode=p.value"
              />

            </div>
          </el-form-item>
          <el-form-item v-if="elementDict.palletSum.viewable" slot="palletSum" class="custom">
            <line-label slot="label" :class="elementDict.palletSum.isRequire ? 'blue' : ''" :label="elementDict.palletSum.label" />
            <el-input-number no="18" style="width:140px;" :value="truckingInfo.palletSum" :disabled="readonly || !elementDict.palletSum.writable" :min="0" :max="999999999999" :precision="0" :controls="false" @input="val=>{truckingInfo.palletSum=val || 0}" />
          </el-form-item>
          <el-form-item v-if="elementDict.po.viewable" slot="po">
            <line-label slot="label" :class="elementDict.po.isRequire ? 'blue' : ''" :label="elementDict.po.label" />
            <el-input v-model="truckingInfo.po" no="po" :disabled="readonly || !elementDict.po.writable" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.loadingAddress && elementDict.loadingAddress.viewable" slot="loadingAddress">
            <line-label slot="label" :class="elementDict.loadingAddress.isRequire ? 'blue' : ''" :label="elementDict.loadingAddress.label" />
            <el-input v-model="truckingInfo.loadingAddress" no="loadingAddress" :disabled="readonly || !elementDict.loadingAddress.writable" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.returnContainerAddress && elementDict.returnContainerAddress.viewable" slot="returnContainerAddress">
            <line-label slot="label" :class="elementDict.returnContainerAddress.isRequire ? 'blue' : ''" :label="elementDict.returnContainerAddress.label" />
            <el-input v-model="truckingInfo.returnContainerAddress" no="returnContainerAddress" :disabled="readonly || !elementDict.returnContainerAddress.writable" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
          </el-form-item>
        </template>
        <template>
          <el-form-item v-if="elementDict.soNo.viewable && job.multiplePickups" slot="soNo" class="custom">
            <line-label slot="label" :class="elementDict.soNo.isRequire ? 'blue' : ''" :label="elementDict.soNo.label" />
            <so-no-selector v-model="truckingInfo.soNo" :so-no="soNo" :disabled="readonly || !elementDict.soNo.writable" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.truckOrderNo.viewable" slot="truckOrderNo" class="custom">
            <line-label slot="label" :class="elementDict.truckOrderNo.isRequire ? 'blue' : ''" :label="elementDict.truckOrderNo.label" />
            <el-input
              v-model="truckingInfo.truckOrderNo"
              no="19"
              :disabled="readonly || !elementDict.truckOrderNo.writable"
              style="width:400px"
              @change="refreshGrid"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.truckingFee.viewable" slot="truckingFee" class="custom">
            <line-label slot="label" :class="elementDict.truckingFee.isRequire ? 'blue' : ''" :label="elementDict.truckingFee.label" />
            <el-input-number
              v-model="truckingInfo.truckingFee"
              no="40"
              :disabled="readonly || !elementDict.truckingFee.writable"
              :min="0"
              :max="999999999999"
              :precision="2"
              controls-position="right"
              style="width:300px"
              @change="truckingFeeCharge"
            />
            <span style="padding-left: 10px;">{{ localCurrency }}</span>
          </el-form-item>
          <el-form-item v-if="elementDict.driverTel.viewable && !isSalesForSzfs" slot="driverTel" class="custom">
            <line-label slot="label" :class="elementDict.driverTel.isRequire ? 'blue' : ''" :label="elementDict.driverTel.label" />
            <el-input v-model="truckingInfo.driverTel" no="41" :disabled="readonly || !elementDict.driverTel.writable" style="width:400px" @change="refreshGrid" />
          </el-form-item>
          <el-form-item v-if="elementDict.actLoadingDate.viewable" slot="actLoadingDate" class="custom">
            <line-label slot="label" :class="elementDict.actLoadingDate.isRequire ? 'blue' : ''" :label="elementDict.actLoadingDate.label" />
            <el-date-picker
              ref="actLoadingDate"
              v-model="truckingInfo.actLoadingDate"
              no="42"
              :disabled="readonly || !elementDict.actLoadingDate.writable"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:400px"
              @blur="()=> { handleBlur('actLoadingDate', null, true, true, truckingInfo) }"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.plateNumber.viewable" slot="plateNumber" class="custom">
            <line-label slot="label" :class="elementDict.plateNumber.isRequire ? 'blue' : ''" :label="elementDict.plateNumber.label" />
            <el-input
              v-if="isEdit"
              v-model="truckingInfo.plateNumber"
              no="43"
              :disabled="readonly || !elementDict.plateNumber.writable"
              style="width:280px;"
              @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
            />
            <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
          </el-form-item>
          <el-form-item v-if="elementDict.driverPhone.viewable && !isSalesForSzfs" slot="driverPhone" :disabled="txtEditEable" class="custom">
            <line-label slot="label" :class="elementDict.driverPhone.isRequire ? 'blue' : ''" :label="elementDict.driverPhone.label" />
            <el-input
              v-model="truckingInfo.driverPhone"
              no="45"
              :disabled="readonly || !elementDict.driverPhone.writable"
              style="width:400px;"
            />
          </el-form-item>
          <el-form-item v-if="elementDict.doorName.viewable" slot="doorName" class="custom">
            <line-label slot="label" :class="elementDict.doorName.isRequire ? 'blue' : ''" :label="elementDict.doorName.label" />
            <cargo-repeat-value-select
              v-model="truckingInfo.doorName"
              :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              filterable
              :allow-create="true"
              :disabled="readonly || !elementDict.doorName.writable"
              clearable
              :options="doorList"
              label-field="name"
              value-field="name"
              unique-field="uuid"
              :match-of-repeat-value="matchOfRepeatDoor"
              style="width: 400px"
              @change="doorsChangeHandler"
            />
            <el-button v-show="$checkPermission(['button_Common_AddSite'])" no="addDoor" :disabled="!isEdit" class="vehicle-btn" type="primary" size="mini" @click="addDoor">{{ $t('Partners.doorInformation') }}</el-button>
          </el-form-item>
          <el-form-item v-if="elementDict.doorManTel.viewable" slot="doorManTel" class="custom">
            <line-label slot="label" :class="elementDict.doorManTel.isRequire ? 'blue' : ''" :label="elementDict.doorManTel.label" />
            <el-input v-model="truckingInfo.doorManTel" no="46" :disabled="readonly || !elementDict.doorManTel.writable" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
            <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
            <el-input v-model="truckingInfo.remarks" no="47" :disabled="readonly || !elementDict.remarks.writable" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
          </el-form-item>
          <el-form-item v-if="elementDict.driverIdCard.viewable" slot="driverIdCard" class="custom">
            <line-label slot="label" :class="elementDict.driverIdCard.isRequire ? 'blue' : ''" :label="elementDict.driverIdCard.label" />
            <el-input v-model="truckingInfo.driverIdCard" no="60" :disabled="readonly || !elementDict.driverIdCard.writable" style="width:400px" />
          </el-form-item>
        </template>
      </template>
      <template v-if="elementDict.containerInfo.viewable" slot="containerInfo">
        <div v-if="!job.multipleCabinets" class="app-main-inner-row operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button no="48" type="primary" :disabled="!(btnEnable.grpTruckOrderBtns || (toExoSystemHc && job.trucking && job.trucking.length > 0))" @click="linkUsageClickHandler">{{ $t('SeaExport.AddPackingInfo') }}
              </el-button>
              <el-button no="49" type="danger" :disabled="!(btnEnable.grpTruckOrderBtns || (toExoSystemHc && job.trucking && job.trucking.length > 0))" @click="delLinkUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}
              </el-button>
              <!--为 编辑状态 el-dropdown 按钮 不可用 新增的按钮-->
              <el-button v-if="!btnEnable.grpTruckOrderBtns" no="50" type="primary" :disabled="!btnEnable.grpTruckOrderBtns">{{ command1 }}
              </el-button>
              <el-dropdown
                v-if="btnEnable.grpTruckOrderBtns"
                split-button
                type="primary"
                style="padding-left: 5px;"
                :disabled="!btnEnable.grpTruckOrderBtns"
                @click="btnConnectedTruckClickHandler()"
                @command="p=>{command1=p;btnConnectedTruckClickHandler()}"
              >
                {{ command1 }}
                <el-dropdown-menu slot="dropdown" :disabled="!btnEnable.grpTruckOrderBtns">
                  <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.DispatchTuckOrder')">{{ $t('SeaExport.DispatchTuckOrder') }}
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.ModifyTuckOrder')">{{ $t('SeaExport.ModifyTuckOrder') }}
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.RevokeTuckOrder')">{{ $t('SeaExport.RevokeTuckOrder') }}
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.SearchTuckOrder')">{{ $t('SeaExport.SearchTuckOrder') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button no="51" :disabled="!btnEnable.grpTruckOrderBtns" type="primary" @click="showTuckOrderLogClickHandler">{{ $t('SeaExport.ShowTuckOrderLog') }}
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="!job.multipleCabinets" style="flex-grow:1;padding:10px">
          <cargo-ag-grid
            v-if="gridVisible.dgUsage"
            config-module="130136"
            no="52"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="usages"
            style="width:100%;height:350px"
            @gridReady="params=>gridApi=params.api"
          />
          <cargo-ag-grid
            v-if="gridVisible.dgUsageG7"
            config-module="130137"
            no="53"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefsG7"
            :row-data="usages"
            style="width:100%;height:350px"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div v-if="job.multipleCabinets" class="app-main-inner-row operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button no="addCabinets" type="primary" :disabled="!btnEnable.grpTruckOrderBtns" @click="linkTruckRecordHandler">{{ $t('SeaExport.AddPackingInfo') }}
              </el-button>
              <el-button no="removeCabinets" type="danger" :disabled="!btnEnable.grpTruckOrderBtns" @click="dellinkTruckRecordHandler">{{ $t('SeaExport.RemovePackingInfo') }}
              </el-button>
              <el-button no="exportPackingInfo" type="primary" :disabled="!btnEnable.grpTruckOrderBtns" @click="exportTruckExcelData">{{ $t('SeaExport.ExportPackingInfo') }}
              </el-button>
              <el-upload
                action="string"
                :http-request="importTruckDataExcel"
                :show-file-list="false"
                :disabled="!btnEnable.grpTruckOrderBtns"
                accept=".xls, .xlsx"
                :before-upload="beforeUploadUsage"
                style="display: inline-block;padding-left: 5px;"
              >
                <el-button no="importPackingInfo" type="primary" :disabled="!btnEnable.grpTruckOrderBtns">
                  {{ $t('SeaExport.ImportPackingInfo') }}
                </el-button>
              </el-upload>
              <el-button no="exportErrorExcel" type="primary" :disabled="!btnEnable.grpTruckOrderBtns || !importExcelResultID" @click="exportErrorExcel">{{ $t('SeaExport.DownloadImportResults') }}
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="job.multipleCabinets" style="flex-grow:1;padding:10px">
          <cargo-ag-grid
            no="gridCabinets"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="cabinetColumnDefs"
            :row-data="truckingRecords"
            style="width:100%;height:350px"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </template>
    </tab-trucking-UICustom-layout>
    <!-- 选择装箱信息弹窗 -->
    <trucking-container-usage-link-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      :modify-usage-in-edit-mode="modifyUsageInEditMode"
      :data="containerUsageDialog.data"
      @selectContainerUsageHandler="selectContainerUsageHandler"
      @saveContainerUsageData="saveContainerUsageHandler"
    />
    <!-- 多柜-选择装箱信息弹窗 -->
    <trucking-container-record-link-dialog
      :visible.sync="containerTruckingRecordDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      @selectTruckingRecordHandler="selectTruckingRecordHandler"
    />
    <!-- 信息维护 -->
    <information-maintenance-dialog
      :visible.sync="informationDialog.visible"
      :site="informationDialog.site"
      :title="informationDialog.title"
      @syncSiteToJob="syncSiteToJob"
      @refresh="loadSites"
    />
    <!-- 日志弹出窗 -->
    <tuck-order-log-dialog
      :visible.sync="truckOrderLogDialog.visible"
      :row-data="truckOrderLogDialog.rowData"
    />
    <!-- 日志弹出窗 -->
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :row-data="errorLogDialog.rowData"
    />
    <!-- 附件 -->
    <upload-common-file
      :visible.sync="uploadCommonFileDialog.visible"
      :model="uploadCommonFileDialog.model"
    />
    <!-- 门点信息公共弹窗 -->
    <door-point-information
      :v-if="addDoorDialog.visible"
      :visible.sync="addDoorDialog.visible"
      :show-area="toExoSystemHc"
      :action="action"
      :site="addDoorDialog.form"
      @loadSites="loadSites"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabTruckingUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTruckingUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TabTruckingUICustom',
  components: { tabTruckingUICustomLayout },
  extends: tabTrucking,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_TRUCKING, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_TRUCKING, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateRequire(truckingList) {
      for (const form of truckingList) {
        for (const name in this.elementDict) {
          const element = this.elementDict[name]
          if (!element.viewable || !element.writable || !element.isRequire) {
            continue
          }
          if (['carryingCmp', 'driver', 'driverName', 'driverTel', 'driverPhone'].includes(name)) {
            if (this.isSalesForSzfs) {
              continue
            }
          }
          if (name === 'soNo') {
            if (!this.job.multiplePickups) {
              continue
            }
          }
          if (!element.fieldNames) {
            continue
          }
          for (const fieldName of element.fieldNames) {
            const field = this.fieldDict[fieldName]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabTruckingForSe')
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-trucking /deep/ {
  .el-form-item {
    .so-no-selector{
      & > span{
        &:first-of-type{
          flex: 1;
        }
      }
    }
  }
  .el-form {
    .plate_number{
      width: 280px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #E4E7ED;
      color: blue;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }
    .vehicle-btn{
      margin-left: 10px;
    }
    .vehicle-tip{
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}
</style>
